import PageJsonLd from './components/PageJsonLd';
import SeoTitle from '@/components/SeoTitle';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import TasksSolved from './components/TasksSolved';
import TaskNavigator from './components/TaskNavigator';
import ProgramNavigator from './components/ProgramNavigator';
import WhyMostTrainingsFail from './components/WhyMostTrainingsFail';
import WhyProgramsWork from './components/WhyProgramsWork';
import CompanyResults from './components/CompanyResults';
import SalesPulseAuditResults from '@/components/feature/SalesPulseAuditResults';
import IndustriesSection from './components/IndustriesSection';
import TrainingFormats from './components/TrainingFormats';
import ProjectTimeline from './components/ProjectTimeline';
import WhyWorkWithAlexey from './components/WhyWorkWithAlexey';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import ReadNextSection from './components/ReadNextSection';
import Footer from '@/components/feature/Footer';

function PageMeta() {
  return (
    <>
      <SeoTitle title="Обучение продажам и переговорам | Business Training" />
      <meta name="description" content="Обучение продажам и переговорам: корпоративные тренинги для отдела продаж, работа с возражениями и рост конверсии." />
      <meta name="keywords" content="корпоративные тренинги, обучение сотрудников, тренинги по продажам, тренинг по переговорам, тренинг по лидерству, тимбилдинг Минск, бизнес-игры Беларусь, тренинг для отдела продаж, soft skills, Минск, Беларусь" />
      <link rel="canonical" href="https://business-training.by/prodazhi-i-peregovory" />
      <meta property="og:title" content="Обучение продажам и переговорам | Business Training" />
      <meta property="og:description" content="Обучение продажам и переговорам: корпоративные тренинги для отдела продаж, работа с возражениями и рост конверсии." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://business-training.by/prodazhi-i-peregovory" />
      <meta property="og:locale" content="ru_RU" />
      <meta property="og:image" content="https://readdy.ai/api/search-image?query=Modern%20corporate%20training%20workshop%20scene%20with%20diverse%20business%20professionals%20engaged%20in%20strategic%20negotiation%20simulation%2C%20bright%20contemporary%20office%20interior%2C%20professional%20atmosphere%2C%20warm%20ambient%20lighting%2C%20clean%20minimalist%20aesthetic%2C%20soft%20neutral%20tones%2C%20elegant%20B2B%20setting%2C%20high-end%20corporate%20photography%20style%2C%20no%20text%20no%20logos%20no%20branding&width=1200&height=630&seq=sales-hub-og-2026&orientation=landscape" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Обучение продажам и переговорам | Business Training" />
      <meta name="twitter:description" content="Обучение продажам и переговорам: корпоративные тренинги для отдела продаж, работа с возражениями и рост конверсии." />
      <meta name="twitter:image" content="https://readdy.ai/api/search-image?query=Modern%20corporate%20training%20workshop%20scene%20with%20diverse%20business%20professionals%20engaged%20in%20strategic%20negotiation%20simulation%2C%20bright%20contemporary%20office%20interior%2C%20professional%20atmosphere%2C%20warm%20ambient%20lighting%2C%20clean%20minimalist%20aesthetic%2C%20soft%20neutral%20tones%2C%20elegant%20B2B%20setting%2C%20high-end%20corporate%20photography%20style%2C%20no%20text%20no%20logos%20no%20branding&width=1200&height=630&seq=sales-hub-og-2026&orientation=landscape" />
      <meta name="last-modified" content="2026-08-03" />
      <meta name="geo.region" content="BY" />
      <meta name="geo.placename" content="Минск" />
      <meta name="geo.position" content="53.9006;27.5590" />
    </>
  );
}

const hubNavLinks = [
  { label: 'Задачи', target: 'tasks' },
  { label: 'Программы', target: 'programs' },
  { label: 'Результаты', target: 'results' },
  { label: 'FAQ', target: 'faq' },
];

export default function SalesHubPage() {
  return (
    <>
      
      <SeoTitle title="Обучение продажам и переговорам | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={hubNavLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />

        <div id="tasks">
          <TaskNavigator />
          <TasksSolved />
        </div>

        <div id="programs">
          <ProgramNavigator />
        </div>

        <WhyMostTrainingsFail />
        <WhyProgramsWork />
        <CompanyResults />
        <SalesPulseAuditResults background="white" />
        <IndustriesSection />
        <TrainingFormats />
        <ProjectTimeline />
        <WhyWorkWithAlexey />
        <FAQSection />
        <CTASection />
        <ReadNextSection />
        <Footer />
      </div>
    </>
  );
}